import {WithStyles, withStyles} from '@material-ui/core/styles';

import {slideStyles} from 'src/Components/Home/Showcase/slideStyles';

const Slide = (props: ISlidesProps) => {
	const eqSlide = props.currentSlideIndex === props.index;

	return (
		<div style={{width: props.width}} className={props.classes.slideWrapper}>
			<div className={props.classes.perspective} style={{perspective: eqSlide ? props.width : 'unset'}}>
				<div
					style={{
						margin: `${props.width / 10}px ${0} ${props.width / 10}px ${
							eqSlide ? props.width / 10 : props.width / 10
						}px `,
					}}
					className={eqSlide ? props.classes.slideActive : props.classes.slide}
				>
					<img className={props.classes.img} src={props.slide} alt={props.description} />
				</div>
			</div>
		</div>
	);
};

interface ISlidesProps extends WithStyles {
	width: number;
	currentSlideIndex: number;
	index: number;
	slide: string;
	description: string;
}

export default withStyles(slideStyles)(Slide);
